import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExpandIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Expand",
    children: /*#__PURE__*/_jsx("path", {
      d: "M24.79 30H14.25c-1.94 0-3.51-1.57-3.51-3.51v-4.85a1.17 1.17 0 0 1 2.24-.01v4.86c0 .69.57 1.24 1.25 1.24h10.55c.69 0 1.25-.55 1.25-1.24v-21c0-.69-.56-1.25-1.25-1.25H14.24c-.69 0-1.25.55-1.25 1.24v4.99a1.17 1.17 0 0 1-2.24.01V5.52c0-1.94 1.57-3.51 3.51-3.51H24.8c1.94 0 3.51 1.57 3.51 3.51v20.97c0 1.94-1.57 3.51-3.51 3.51zM19.3 15.01H9.16v-2.36a.807.807 0 0 0-1.36-.59l-3.85 3.51c-.16.15-.26.35-.26.59s.1.44.26.59l3.85 3.51c.14.13.33.21.54.21.45 0 .81-.36.81-.8v-2.34h10.14a1.17 1.17 0 0 0 .01-2.24s.01-.06.01-.06Z"
    })
  }));
};